import { WithNamePrefixes } from '~/core/shared/types';

// The dotted name a form field is registered, rendered and read under, and the
// control's `id`: the prefixes of the row it sits in, then the field's own name.
export const getFullFieldName = (
  name: string,
  namePrefixes: WithNamePrefixes['namePrefixes'] = [],
): string => [...namePrefixes, name].join('.');
